import React from "react";
import styled from 'styled-components';


const Wrapper  = styled.div.withConfig({displayName:'-Wrapper '})`
  font-family: 'Raleway', sans-serif;
  display: ${props => props.display};
  width: ${props => props.width};
  ${props => props.display === "inline" ? "z-index: 3;" : null}
  vertical-align: middle;
  border-radius: 42px;
  border: 2px solid black;
  color: #000;
  outline: none;
  box-shadow: none;
  text-transform: uppercase;
  text-align: center;
  background-clip: border-box;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  box-sizing: border-box;
  letter-spacing: 1px;
  font-size: inherit;
  cursor: ${props => props.disabled ? "default" : "pointer"};


  pointer-events: ${props => props.noHover ? "none" : "auto"};box-shadow: 0px 1px 2px #687FE262;

  -webkit-transition: all 100ms linear;
  -ms-transition: all 100ms linear;
  transition: all 100ms linear;

  &, & * {
    box-sizing: border-box;
  }

  &:active, &:focus{
    box-shadow: none;
    outline: none;
    text-decoration: none;
  }

  ${props => props.size === "medium" ? `
    height: 42px;
    padding: 0px 24px 0px;
    min-width: 120px;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
  ` : props => props.size === "small" ? `
    height: 26px;
    padding: 0px 12px 0px;
    min-width: 80px;
    font-size: 10px;
    font-weight: 800;
    line-height: 10px;
  ` : null };

  ${props => props.variant === "default" ? `
    color: #ffffff;
    background-color: #0d609d;
    border-color: #0d609d;

    &:hover{
      color: #0d609d;
      background-color: #ffffff;
      border-color: #0d609d;
    }
  ` : props.variant === "default-o" ? `
    color: #0d609d;
    background-color: #ffffff;
    border-color: #0d609d;

    &:hover{
      color: #ffffff;
      background-color: #0d609d;
      border-color: #0d609d;
    }
  ` : props.variant === "disabled" ? `
    color: #ffffff;
    background-color: #0d609d;
    border-color: #0d609d;
    opacity: 0.7;
  ` : `

  `};
`;


const Content = styled.div.withConfig({displayName:'-Content'})`
  display: flex;
  height: 100%;
  justify-content: space-around;
  align-items: center;
`;
// const IconWrapper = styled.div.withConfig({displayName:'-IconWrapper'})`
//   margin-right: ${props => props.noText ? 0 : 3}px;
//   line-height: 0px;
//   margin-top: -5px;
//   margin-bottom: -5px;
//   flex-grow: 0;
//   flex-shrink: 0;
// `;
// const TextWrapper = styled.div.withConfig({displayName:'-TextWrapper'})`
//   flex-grow: 1;
//   flex-shrink: 1;
// `;



const Button = ({
    variant = "default",
    size = "medium",
    display = "inline-block",
    width = "auto",
    disabled = false,
    noHover = false,
    onClick,
    children
  }) => {
  return (
    <Wrapper
      variant={variant}
      size={size}
      display={display}
      width={width}
      onClick={onClick}
      disabled={disabled}
      noHover={noHover}
    >
      <Content>
        {children}
      </Content>
    </Wrapper>
  )
}

export default Button;
